/**
 * email-notify — i PALLINI della Posta (28/07, richiesta utente: «quando arriva posta o
 * follow up etc, notifica: cerchietto in sidebar e seconda sidebar»).
 *
 * Perché un bundle a sé, EAGER, invece di metterlo nel modulo Posta: il modulo è lazy e viene
 * caricato solo quando si apre la Posta. Un avviso che compare soltanto dopo essere entrati
 * nella Posta non avvisa nessuno. Questo file è minuscolo e vive nel boot: chiede due numeri
 * al server e li pubblica sul bus della shell, che li disegna sul rail (somma) e sulle voci
 * del sottomenù (per voce).
 *
 * Costo: una richiesta ogni 60 secondi che risponde due interi. Si ferma quando la scheda è
 * in secondo piano (niente traffico inutile) e riparte al ritorno, chiedendo subito.
 *
 * NON emette nulla se il bus non c'è (shell vecchia o kill-switch): resta inerte.
 */

const OGNI_MS = 60000;          // un minuto: la posta non arriva al millisecondo
const CHIAVE_SPENTO = 'shell_email_badge';   // kill-switch per-browser: '0' + reload

export function installEmailNotify(win) {
  if (!win || !win.Workspaces || !win.Workspaces.bus) return false;
  try {
    if (win.localStorage && win.localStorage.getItem(CHIAVE_SPENTO) === '0') return false;
  } catch (e) { /* storage negato: si procede */ }

  const W = win.Workspaces;
  let ultimoNonLetti = null;
  let ultimoFollowup = null;
  let inCorso = false;

  function base() {
    // stessa origine dell'app; il token vive dove lo mette il client-adapter
    try { return (win.api && win.api.getBase && win.api.getBase()) || '/api'; } catch (e) { return '/api'; }
  }
  function token() {
    try { return (win.api && win.api.getToken && win.api.getToken()) || ''; } catch (e) { return ''; }
  }

  async function leggi() {
    if (inCorso) return;
    const t = token();
    if (!t) return;                       // non autenticato: nessun conteggio, nessun rumore
    inCorso = true;
    try {
      const r = await win.fetch(base() + '/email/badge', { headers: { Authorization: 'Bearer ' + t } });
      if (!r.ok) return;                  // 401/403/500: si riproverà al giro dopo, in silenzio
      const d = await r.json();
      const nl = Number(d && d.unread) || 0;
      const fu = Number(d && d.followups) || 0;
      // si pubblica solo ciò che CAMBIA: il bus è condiviso e il rail ridisegna a ogni evento
      if (nl !== ultimoNonLetti) {
        ultimoNonLetti = nl;
        W.bus.emit('nav:badge', { module: 'email', item: 'inbox', count: nl });
      }
      if (fu !== ultimoFollowup) {
        ultimoFollowup = fu;
        W.bus.emit('nav:badge', { module: 'email', item: 'followup', count: fu });
      }
    } catch (e) {
      /* rete assente o server giù: i pallini restano com'erano, nessun errore a schermo */
    } finally {
      inCorso = false;
    }
  }

  leggi();
  const timer = win.setInterval(() => {
    // scheda nascosta = nessuna richiesta: il conteggio serve a chi sta guardando
    if (win.document && win.document.hidden) return;
    leggi();
  }, OGNI_MS);

  // tornando sulla scheda si vuole il numero fresco subito, non fra un minuto
  if (win.document && win.document.addEventListener) {
    win.document.addEventListener('visibilitychange', () => {
      if (!win.document.hidden) leggi();
    });
  }
  // dopo un invio o una lettura il numero cambia: la Posta lo annuncia sul bus e qui si rilegge
  try {
    W.bus.on('email:cambiato', () => leggi(), { replay: false });
    W.bus.on('shell:navigate', (p) => { if (p && p.module === 'email') leggi(); }, { replay: false });
  } catch (e) { /* bus senza on(): pazienza, resta il timer */ }

  win.__emailNotifyTimer = timer;   // per poterlo spegnere da console in collaudo
  return true;
}

// side-effect solo nel browser (i test importano il file sotto node)
if (typeof window !== 'undefined' && !window.__emailNotifyInstallato) {
  if (installEmailNotify(window)) window.__emailNotifyInstallato = true;
}
